import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeAutenticacaoRemota: RouteConfig[] = [
	{
		path: '/autenticacao-remota',
		name: 'Autenticações Remotas',
		components: {
			default: () => import('@/views/application/usuarios/TelaDeAutenticacoesRemotas.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'autenticacao-remota' as TipoDeRecurso,
		},
	},
]

export default rotasDeAutenticacaoRemota